<template>
    <span>
        {{ humanReadable }}
        <template v-if="!disabled">
            <v-btn icon small v-bind="{ disabled, loading }" color="info" @click="edit"><v-icon>schedule</v-icon></v-btn>
            <v-dialog v-model="editing" persistent>
                <v-card>
                    <v-toolbar dense flat dark color="info">{{ title }}</v-toolbar>
                    <v-card-text>
                        <v-form v-model="validForm">
                            <v-text-field type="number" v-model="editData.months" v-bind="{ disabled, loading }"
                                label="Mesi" :rules="rules.months" :hint="monthHint"></v-text-field>
                            <v-text-field type="number" v-model="editData.weeks" v-bind="{ disabled, loading }"
                                label="Settimane" :rules="rules.weeks" :hint="weeksHint"></v-text-field>
                            <v-text-field type="number" v-model="editData.days" v-bind="{ disabled, loading }"
                                label="Giorni" :rules="rules.days" :hint="daysHint"></v-text-field>
                            <v-text-field type="number" v-model="editData.hours" v-bind="{ disabled, loading }" label="Ore"
                                :rules="rules.hours"></v-text-field>
                            <v-select :items="[0, 30]" v-model="editData.minutes" v-bind="{ disabled, loading }"
                                label="Minuti" :rules="rules.minutes"></v-select>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="close"><v-icon left>close</v-icon>{{ trans('common.close') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="save" v-bind="{ disabled: disabled || !validForm, loading }"><v-icon
                                left>save</v-icon>{{ trans('common.save') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </span>
</template>

<script>
import { Vuelidator, Rule } from '../Vuelidator/index.js';


class WorkTimeParser {
    constructor(hoursPerDay, daysPerWeek, daysInMont) {
        this.hoursPerDay = hoursPerDay;
        this.daysPerWeek = daysPerWeek;
        this.daysInMont = daysInMont;
    }

    fromHours(h) {
        const hoursInMonth = this.hoursPerDay * this.daysInMont;
        const hoursPerWeek = this.hoursPerDay * this.daysPerWeek;

        const months = Math.floor(h / hoursInMonth);
        h = h % hoursInMonth
        const weeks = Math.floor(h / hoursPerWeek);
        h = h % hoursPerWeek;
        const days = Math.floor(h / this.hoursPerDay);
        h = h % this.hoursPerDay;

        const hours = Math.floor(h);
        const minutes = Math.floor((h % 1) * 60);

        return {
            months,
            weeks,
            days,
            hours,
            minutes,
        };
    }
    toHours(obj) {
        const hoursInMonth = this.hoursPerDay * this.daysInMont;
        const hoursPerWeek = this.hoursPerDay * this.daysPerWeek;

        let h = 0;

        if (obj.hours)
            h += parseInt(obj.hours);

        if (obj.minutes)
            h += parseInt(obj.minutes) / 60;

        if (obj.days)
            h += parseInt(obj.days) * this.hoursPerDay;

        if (obj.weeks)
            h += parseInt(obj.weeks) * hoursPerWeek;

        if (obj.months)
            h += parseInt(obj.months) * hoursInMonth;

        return h;
    }

    humanReadable(obj) {
        let arr = [];
        const trs = { months: 'Mese', weeks: 'Settimana', days: 'Giorno', hours: 'Ora', minutes: 'Minuto' };
        const trm = { months: 'Mesi', weeks: 'Settimane', days: 'Giorni', hours: 'Ore', minutes: 'Minuti' };

        for (let k of ['months', 'weeks', 'days', 'hours', 'minutes']) {
            const v = obj[k]
            if (v > 0) {
                arr.push(v + ' ' + (v > 1 ? trm[k] : trs[k]));
            }
        }

        let last = arr.pop();
        return arr.length > 0 ? arr.join(', ') + ' e ' + last : last;
    }
}

export default {
    props: {
        value: {},
        disabled: { default: false },
        loading: { default: false },
        title: { default: 'Modifica durata' },
        hoursPerDay: { default: 8, type: Number },
        daysPerWeek: { default: 5, type: Number },
        daysInMont: { default: 20, type: Number },
    },
    data() {
        const validator = new Vuelidator({
            months: [Rule.nullable(), Rule.numeric(), Rule.min(0)],
            weeks: [Rule.nullable(), Rule.numeric(), Rule.min(0)],
            days: [Rule.nullable(), Rule.numeric(), Rule.min(0)],
            hours: [Rule.nullable(), Rule.numeric(), Rule.min(0)],
            minutes: [Rule.nullable(), Rule.numeric(), Rule.min(0)],
        });
        const rules = validator.getRules();
        const parser = new WorkTimeParser(this.hoursPerDay, this.daysPerWeek, this.daysInMont);
        return {
            val: this.value,
            editing: false,
            editData: {
                months: 0,
                days: 0,
                hours: 0,
                minutes: 0,
            },
            validForm: false,
            rules,
            parser,
        }
    },
    mounted() {
        this.parseVal();
    },
    computed: {
        humanReadable() {
            return (this.value) ? this.parser.humanReadable(this.editData) : '-';
        },
        monthHint() { return `Per ${this.daysInMont} giorni al mese`; },
        weeksHint() { return `Per ${this.daysPerWeek} giorni alla settimana`; },
        daysHint() { return `Per ${this.hoursPerDay} ore al giorno`; },
    },
    methods: {
        edit() {
            this.editing = true;
        },
        parseVal() {
            this.editData = this.parser.fromHours(this.value);
        },
        save() {
            const hours = this.parser.toHours(this.editData)
            console.warn('hours', hours, this.editData);
            this.val = hours;
            this.close();

        },
        close() {
            this.editing = false;
        },
    },
    watch: {
        value() {
            this.parseVal();
            this.val = this.value;
        },
        val() {
            this.parseVal();
            this.$emit('input', this.val);
        }
    }

}
</script>